<template>
    <div class="TQ_center">

        <!-- outer tabs-->
        <div class="TQ_padding_8px TQ_direction_ltr TQ_margin_top_16px">
            <div v-for="(tab_o, key_s, index_n) in outerTabs_oo"
                 :class="{
                    'TQ_borderRadius_left' : index_n === 0,
                    'TQ_borderRadius_right': index_n === Object.keys(outerTabs_oo).length-1,
                    'TQ_bg_purple_dark': outerTab_selectedTabId_n === tab_o.id_n,
                 }"
                 @click="m_outerTab_clickTab_f(tab_o.id_n)"
                 class="TQ_inline TQ_padding_12px TQ_box_shadow TQ_bg_white TQ_clickable TQ_text_20px TQ_width_150px">
                {{tab_o.label_s}}
            </div>
        </div>

        <!-- outer body -->
        <div v-if="outerTab_selectedTabId_n" class="TQ_grid_col_auto1fr TQ_grid_gap_8px">

            <!-- inner tabs -->
            <div class="TQ_bg_white">
                <div v-for="(val, key_s) in co_getInnerTabs_os"
                     @click="innerTab_selectTabId_s = val"
                     :class="innerTab_selectTabId_s === val && 'TQ_bg_gold'"
                     class="TQ_padding_8px TQ_border_bottom TQ_align_initial TQ_clickable TQ_unselectable ">
                    {{key_s}}
                </div>

                <div class="TQ_padding_8px TQ_align_initial TQ_bg_green TQ_box_shadow2 TQ_clickable "
                     @click="m_innerTab_addNew_f"
                     v-if="[outerTabs_oo.blog.id_n, outerTabs_oo.questMolds.id_n].includes(outerTab_selectedTabId_n)">
                    Add New
                </div>
            </div>

            <!-- inner body -->
            <div class="TQ_bg_white TQ_padding_16px" >

                <div v-if="co_getSelectedData_o">

                    <!-- 1) questMold - questId/minPoints  -->
                    <div v-if="[outerTabs_oo.questMolds.id_n].includes(outerTab_selectedTabId_n)">

                        <!-- questId-->
                        <div  class="TQ_padding_8px TQ_inline">
                            <div>
                                QuestId
                            </div>
                            <input class="TQ_padding_8px TQ_center"  v-model="co_getSelectedData_o.qm_questId_uid">
                        </div>

                        <!-- points  -->
                        <div>
                            <div>
                                Features
                            </div>

                            <div>
                                {{co_getSelectedData_o.qm_featuresIds_ae}}
                            </div>
                        </div>
                    </div>

                    <!-- 2) questMold/helpers/features - slides Data  -->
                    <div v-if="[outerTabs_oo.versions.id_n , outerTabs_oo.questMolds.id_n, outerTabs_oo.helpers.id_n, outerTabs_oo.features.id_n].includes(outerTab_selectedTabId_n)">

                        <!-- 1.1) lang cods -->
                        <div v-for="langCode_e in enum_langCodes"
                             class="TQ_padding_8px TQ_bg_gray4 TQ_clickable TQ_padding_4px TQ_inline TQ_margin_2px"
                             @click="innerTab_selectedLangCode_e = langCode_e" :class="{'TQ_bg_purple' : innerTab_selectedLangCode_e === langCode_e }">
                            {{format_langCode_fs(langCode_e)}}
                        </div>

                        <!-- add/ remove lang code -->
                        <div class="TQ_padding_8px TQ_margin_top_8px">
                            <div v-if="co_getSelectedData_o.ml_langArr_ae.includes(innerTab_selectedLangCode_e)"
                                 class="TQ_padding_8px TQ_bg_red  TQ_inline TQ_borderRadius TQ_box_shadow TQ_clickable"
                                 @click="co_getSelectedData_o.ml_langArr_ae.splice(co_getSelectedData_o.ml_langArr_ae.indexOf(innerTab_selectedLangCode_e), 1)">
                                Remove Lang
                            </div>

                            <div v-else>
                                <div class="TQ_padding_8px TQ_bg_purple TQ_inline TQ_borderRadius TQ_box_shadow TQ_clickable"
                                     @click="co_getSelectedData_o.ml_langArr_ae.push(innerTab_selectedLangCode_e)">
                                    Add Lang
                                </div>
                            </div>
                        </div>

                        <!-- 1.2) slides -->
                        <div v-if="co_getSelectedData_o.ml_langArr_ae.includes(innerTab_selectedLangCode_e)">

                            <!-- slides -->
                            <div v-for="slideData_c in co_getSelectedData_o.so_slides_blc_ac[innerTab_selectedLangCode_e]" class="TQ_inline TQ_margin_4px TQ_border TQ_borderRadius">

                                <!-- slide image-->
                                <div class="TQ_borderRadius TQ_box_shadow TQ_height_200px TQ_width_300px TQ_clickable TQ_center"
                                     @click="m_chooseFile_f((file_c) => {slideData_c.sd_imageUrl_s = file_c.fi_url_s})">
                                    <tq-img-fill-blur v-if="slideData_c.sd_imageUrl_s"
                                                      p_max-width_s="300px" p_height_s="200px" :pp_img-url_s="slideData_c.sd_imageUrl_s"/>

                                </div>
                                <hr>

                                <!-- title -->
                                <div>
                                    <div>
                                        Title
                                    </div>

                                    <div class="TQ_padding_8px">
                                        <input class="TQ_padding_4px TQ_width_100p  TQ_borderBox" v-model="slideData_c.sd_title_s" />
                                    </div>
                                </div>
                                <hr>

                                <!-- description  -->
                                <div class="TQ_padding_8px ">
                                    <div>
                                        Description
                                    </div>

                                    <div>
                                        <textarea class="TQ_padding_4px" v-model="slideData_c.sd_description_s" rows="5" cols="40"/>
                                    </div>

                                </div>
                            </div>

                            <!-- add -->
                            <div @click="m_pushSlide_f" >
                                <div class="TQ_padding_8px TQ_inline TQ_bg_purple TQ_clickable TQ_margin_8px TQ_borderRadius">
                                    Add Slide
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- 3) blog -->
                    <div v-if="[outerTabs_oo.blog.id_n].includes(outerTab_selectedTabId_n)">

                        <!-- 1.1) id -->
                        <div class="TQ_text_24px TQ_padding_8px">
                            {{ co_getSelectedData_o.ba_articleId_uid }}
                        </div>
                        <hr>

                        <!-- 1.2) active/ not Active-->
                        <div class="TQ_padding_8px">
                            <div class="TQ_text_20px ">
                                {{ass_strings.oneWord_active[store_system_langCode_ve.val]}}
                            </div>
                            <tq-toggle-switch class="TQ_inline TQ_verticalAlignMiddle " width="40px" height="22px"  p_circle-size_s="14px"
                                              v-model="co_getSelectedData_o.ba_active_b"/>
                        </div>
                        <hr>

                        <!-- 1.3) created date -->
                        <div class="TQ_padding_8px">
                            <div class="TQ_text_20px ">
                                {{ass_strings.twoWords_createdDate[store_system_langCode_ve.val]}}
                            </div>

                            <input type="date"
                                   @input="(event) => {co_getSelectedData_o.ba_createdTime_t = (new Date(event.target.value)).getTime()}"
                                   :key="co_getSelectedData_o.ba_articleId_uid" class="TQ_padding_4px"/>
                            <div class="TQ_padding_4px"></div>
                            <div >
                                {{ format_date_YYYY_MM_DD_fs(co_getSelectedData_o.ba_createdTime_t) }}
                            </div>
                        </div>
                        <hr>

                        <!-- 1.4) lang cods -->
                        <div class="TQ_padding_8px">
                            <div v-for="langCode_e in enum_langCodes"
                                 class="TQ_padding_8px TQ_bg_gray4 TQ_clickable TQ_padding_4px TQ_inline TQ_margin_2px"
                                 @click="innerTab_selectedLangCode_e = langCode_e" :class="{'TQ_bg_purple' : innerTab_selectedLangCode_e === langCode_e }">
                                {{format_langCode_fs(langCode_e)}}
                            </div>

                            <!-- add/ remove lang code -->
                            <div class="TQ_padding_8px TQ_margin_top_8px">
                                <div v-if="co_getSelectedData_o.ba_langArr_ae.includes(innerTab_selectedLangCode_e)"
                                     class="TQ_padding_8px TQ_bg_red  TQ_inline TQ_borderRadius TQ_box_shadow TQ_clickable"
                                     @click="() => {co_getSelectedData_o.ba_langArr_ae.splice(co_getSelectedData_o.ba_langArr_ae.indexOf(this.innerTab_selectedLangCode_e), 1)}">
                                    remove lang code
                                </div>

                                <div v-else>
                                    <div class="TQ_padding_8px TQ_bg_purple TQ_inline TQ_borderRadius TQ_box_shadow TQ_clickable" @click="co_getSelectedData_o.ba_m_addNewLangCode_f(innerTab_selectedLangCode_e)">
                                        add new lang code
                                    </div>
                                </div>
                            </div>

                        </div>
                        <hr>

                        <!-- 1.5) body -->
                        <div v-if="co_getSelectedData_o.ba_langArr_ae.includes(innerTab_selectedLangCode_e)">

                            <!-- 1.5.1) image -->
                            <div class="TQ_clickable TQ_inline TQ_border TQ_padding_4px TQ_maxWidth_300px"
                                 @click="m_chooseFile_f(file_c => co_getSelectedData_o.ba_mainImage_blc_c[innerTab_selectedLangCode_e] = file_c)">
                                <div v-if=co_getSelectedData_o.ba_mainImage_blc_c[innerTab_selectedLangCode_e] >
                                    <tq-img-fill-blur
                                        p_height_s="200px"
                                        :pp_img-url_s="co_getSelectedData_o.ba_mainImage_blc_c[innerTab_selectedLangCode_e].fi_url_s">
                                    </tq-img-fill-blur>
                                </div>
                                <div v-else class="TQ_bg_gray4 TQ_padding_32px" >
                                    {{ass_strings.twoWords_addImage[store_system_langCode_ve.val]}}
                                </div>
                            </div>

                            <!-- 1.5.2 basic info -->
                            <div class="TQ_padding_8px TQ_maxWidth_300px TQ_center">

                                <div class="TQ_margin_bottom_4px">
                                    <div class="TQ_align_initial TQ_text_14px TQ_text_bold">{{ass_strings.oneWord_name[store_system_langCode_ve.val]}}</div>
                                    <tq-textarea-autosize
                                        class="TQ_padding_8px"
                                        :p_placeholder_s="ass_strings.oneWord_name[store_system_langCode_ve.val]"
                                        :pe_input_f="(text_s) => {co_getSelectedData_o.ba_name_blc_s[innerTab_selectedLangCode_e] = text_s}"
                                        :p_text_s="co_getSelectedData_o.ba_name_blc_s[innerTab_selectedLangCode_e]">
                                    </tq-textarea-autosize>
                                </div>


                                <div class="TQ_margin_bottom_4px">
                                    <div class="TQ_align_initial TQ_text_14px TQ_text_bold">{{ass_strings.oneWord_title[store_system_langCode_ve.val]}}</div>

                                    <tq-textarea-autosize
                                        class="TQ_padding_8px"
                                        :p_placeholder_s="ass_strings.oneWord_title[store_system_langCode_ve.val]"
                                        :pe_input_f="(text_s) => {co_getSelectedData_o.ba_title_blc_s[innerTab_selectedLangCode_e] = text_s}"
                                        :p_text_s="co_getSelectedData_o.ba_title_blc_s[innerTab_selectedLangCode_e]">
                                    </tq-textarea-autosize>
                                </div>

                                <div class="TQ_margin_bottom_4px">
                                    <div class="TQ_align_initial TQ_text_14px TQ_text_bold">{{ass_strings.oneWord_description[store_system_langCode_ve.val]}}</div>
                                    <tq-textarea-autosize
                                        class="TQ_padding_8px"
                                        :p_placeholder_s="ass_strings.oneWord_description[store_system_langCode_ve.val]"
                                        :pe_input_f="(text_s) => {co_getSelectedData_o.ba_description_blc_s[innerTab_selectedLangCode_e] = text_s}"
                                        :p_text_s="co_getSelectedData_o.ba_description_blc_s[innerTab_selectedLangCode_e]">
                                    </tq-textarea-autosize>
                                </div>

                            </div>

                            <!-- 1.5.3) editor -->
                            <tq-wysiwyg-editor
                                class="TQ_maxWidth_900px"
                                :key="co_getSelectedData_o.ba_articleId_uid + innerTab_selectedLangCode_e"
                                :pe_choose-file_f="m_chooseFile_f"
                                height="700px"
                                :p_value_html="co_getSelectedData_o.bc_content_blc_c[innerTab_selectedLangCode_e].w_body_s"
                                :pe_update-value_f="(newValue_html) => {co_getSelectedData_o.bc_content_blc_c[innerTab_selectedLangCode_e].w_body_s = newValue_html}"
                            />

                        </div>

                    </div>

                    <!-- 5) Admin Emails -->
                    <div v-if="[outerTabs_oo.emails.id_n].includes(outerTab_selectedTabId_n)">

                        <!-- email -->
                        <div class="TQ_maxWidth_800px TQ_center TQ_padding_8px">
                            <!-- lang codes -->
                            <div class="TQ_grid_col_1fr1fr1fr1fr">
                                <div v-for="langCode_e in enum_langCodes"
                                     class="TQ_padding_8px TQ_bg_gray4 TQ_clickable TQ_padding_4px TQ_inline  TQ_margin_2px"
                                     @click="innerTab_selectedLangCode_e = langCode_e" :class="{'TQ_bg_purple' : innerTab_selectedLangCode_e === langCode_e }">
                                    {{format_langCode_fs(langCode_e)}}
                                </div>
                            </div>

                            <div class="TQ_margin_top_16px" :style="{'direction' : helper_getDirectionByLangCode_fe(innerTab_selectedLangCode_e)}">

                                <!-- title -->
                                <input v-model="co_getSelectedData_o.ae_title_blc_s[innerTab_selectedLangCode_e]"
                                       class="TQ_text_20px TQ_padding_8px TQ_width_100p TQ_borderBox TQ_center TQ_bg_black">

                                <!-- body -->
                                <tq-wysiwyg-editor  id="editMoreInfo"
                                                    height="600px"
                                                    :key="innerTab_selectTabId_s + innerTab_selectedLangCode_e"
                                                    :p_value_html="co_getSelectedData_o.ae_body_blc_html[innerTab_selectedLangCode_e]"
                                                    :pe_update-value_f="(newValue_html) => {co_getSelectedData_o.ae_body_blc_html[innerTab_selectedLangCode_e] = newValue_html}"
                                                    :pe_choose-file_f="m_chooseFile_f"/>

                            </div>
                        </div>

                        <!-- preview -->
                        <div class="TQ_border TQ_padding_8px">
                            <div>{{ co_previewEmail_title_fs }}</div>
                            <div v-html="co_previewEmail_body_fs"></div>
                        </div>

                    </div>

                    <!-- update btn -->
                    <tq-loader-container :p_show-loader_b="showLoader_b">
                        <tq-btn-approve
                            class="TQ_margin_16px TQ_text_20px TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius TQ_clickable TQ_width_200px"
                            :approve-cb="m_update_f"
                            :popup-text="ass_strings.question_requestGeoLocation"
                            :system-lang-code="store_system_langCode_ve.val">
                            Update
                        </tq-btn-approve>

                    </tq-loader-container>

                </div>

            </div>

        </div>

        <!-- tests functions  -->
        <div v-if="false">
            <div class="TQ_center">
                <div class="TQ_bg_gold TQ_inline TQ_padding_16px TQ_clickable" @click="m_test_functions_f">
                    Test functions
                </div>
            </div>

            <div class="TQ_border TQ_padding_8px">
                <div>{{testEmailTitle_s}}</div>
                <div v-html="testEmailBody_s"></div>
            </div>
        </div>

        <!-- Choose file -->
        <tq-popup :show="popup_chooseFile_show_vb" width="100%" class="TQ_center" padding="0" :show-close-btn="true">
            <tq-choose-file v-if="popup_chooseFile_show_vb.val"
                            :p_can-choose-image_b="true"
                            :p_can-choose-video_b="true"
                            :p_can-choose-audio_b="true"
                            :pe_choose-file_f="popup_chooseFile_cb_f"/>
        </tq-popup>

    </div>
</template>

<script>

    import TqWysiwygEditor from "../../components/complex/TqWysiwygEditor";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqDropdown from "../../components/basic/TqDropdown";
    import TqBtnApprove from "../../components/basic2/TqBtnApprove";
    import {store_getStateValue_vo, store_var} from "@/store";
    import {
        server_blogArticle_getNewTicket_f,
        server_forumData_set_f,
        server_blogArticles_once_fp,
        serverPre_moreInfo_get_one_f,
        server_questMold_update_f,
        server_questMold_getAll_f,
        serverPre_moreInfo_update_f
    } from "@/scripts/Server/S_ServerPre";
    import TqCard from "../../components/basic/TqCard";
    import TqTabs from "../../components/basic/TqTabs";
    import {
        enum_emailsIds_uid, enum_moreInfo_featuresIds_s,
        enum_featuresMinPoints,
        enum_langCodes,
        enum_moreInfo_helpersIds_s, enum_moreInfo_versionsRelease_s
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {format_date_YYYY_MM_DD_fs, format_langCode_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import TqToggleSwitch from "../../components/basic/TqToggleSwitch";
    import TqLoaderContainer from "../../components/basic/TqLoaderContainer";
    import TqPopup from "../../components/basic/TqPopup";
    import TqChooseFile from "../../components/unpure/FcucDrive";
    import TqDisplayFile from "../../components/mediaComponenets/TqDisplayFile";
    import TqImgFillBlur from "../../components/basic2/TqImgFillBlur";
    import TqTextareaAutosize from "../../components/basic/TqTextareaAutosize";
    import TqTextarea from "../../components/basic/TqTextarea";
    import {obj_map_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import {notification_notify} from "@/scripts/S_Notification";
    import {helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";
    import {
        FB_MoreInfo,
        FB_AdminEmail,
        FB_QuestTicket,
        FB_UserDataSub_CreatorPaymentInfo,
        FB_UserData,
        FB_QuestEvent,
        FB_QuestMold, FB_SlideData,
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import {date_nowTime_t} from "../../../functions/src/shareCode/Share_S_Date";
    import TqLoaderButton from "@/components/basic2/TqLoaderButton";
    import {
        serverBig_adminEmail_getOnce_f,
        serverBig_adminEmail_update_f, serverBig_questExplore_once_f, serverBig_questBody_once_fp,
    } from "@/scripts/Server/S_ServerFirestore";
    import {re_startAndEndWith_s} from "@/scripts/S_RegularExp";
    import {email_bodyWrapper_fs, email_swapVars_f,} from "../../../functions/src/server/Helpers/Fun_S_EamilsFormater";

    export default {
        name: "v_Admin_Blogs",
        components: {
            TqLoaderButton,
            TqTextarea,
            TqTextareaAutosize,
            TqImgFillBlur,
            TqDisplayFile,
            TqChooseFile,
            TqPopup,
            TqLoaderContainer,
            TqToggleSwitch,
            TqTabs,
            TqCard,
            TqBtnApprove,
            TqDropdown,
            TqWysiwygEditor
        },
        data(){
            return {

                // topTabs
                outerTabs_oo :{
                    versions    : {label_s: 'MI- Versions',  id_n: 3},
                    helpers     : {label_s: 'MI- Helpers',   id_n: 2,},
                    features    : {label_s: 'MI- Features',  id_n: 4},

                    questMolds  : {label_s: 'Quest Molds',  id_n: 6},

                    blog        : {label_s: 'Blog',         id_n: 1},
                    emails      : {label_s: 'Emails',       id_n: 5},
                },

                outerTab_selectedTabId_n : 0,
                innerTab_selectTabId_s : null,
                innerTab_selectedLangCode_e : enum_langCodes.english,
                showLoader_b : false,

                // choose file
                popup_chooseFile_show_vb : {val : false},
                popup_chooseFile_cb_f : () => {},

                // test
                testEmailTitle_s : "",
                testEmailBody_s : "",


                // server
                server_articlesData_byArticleId_c   : undefined,
                server_questMolds_byQuestId_c       : undefined,
                server_moreInfo_byId_c              : {},
                server_adminEmails_byId_uid         : {},


                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // imports
                ass_strings                         : ass_strings,
                enum_langCodes                      : enum_langCodes,
                enum_moreInfo_helpersIds_s          : enum_moreInfo_helpersIds_s,
                enum_featuresMinPoints              : enum_featuresMinPoints,
                enum_emailsIds_uid                  : enum_emailsIds_uid,
                format_langCode_fs                  : format_langCode_fs,
                format_date_YYYY_MM_DD_fs           : format_date_YYYY_MM_DD_fs,
                helper_getDirectionByLangCode_fe    : helper_getDirectionByLangCode_fe,

            }
        },
        computed:{

            co_getInnerTabs_os(){
                switch(this.outerTab_selectedTabId_n){
                    case this.outerTabs_oo.blog.id_n:

                        if(this.server_articlesData_byArticleId_c === undefined) {
                            this.server_articlesData_byArticleId_c = {}

                            server_blogArticles_once_fp(false, (articlesData_byArticleId_c) => {
                                this.server_articlesData_byArticleId_c = articlesData_byArticleId_c
                            })
                        }

                        let ansArticles_os = {}
                        let i =0
                        for(let articleId_uid in this.server_articlesData_byArticleId_c){
                            let key = (i++) + ") " + this.server_articlesData_byArticleId_c[articleId_uid].ba_name_blc_s[enum_langCodes.hebrew]
                            ansArticles_os[key] = articleId_uid
                        }

                        return ansArticles_os

                    case this.outerTabs_oo.questMolds.id_n:

                        if(this.server_questMolds_byQuestId_c === undefined){
                            this.server_questMolds_byQuestId_c = []

                            server_questMold_getAll_f((questMolds_byQuestId_c) => {
                                this.server_questMolds_byQuestId_c = questMolds_byQuestId_c
                            })
                        }

                        let ansQuestMold_os = {}
                        for(let questId_s in this.server_questMolds_byQuestId_c){
                            ansQuestMold_os[questId_s] = questId_s
                        }

                        return ansQuestMold_os

                    case this.outerTabs_oo.versions.id_n:
                        return enum_moreInfo_versionsRelease_s

                    case this.outerTabs_oo.helpers.id_n:
                        return enum_moreInfo_helpersIds_s

                    case this.outerTabs_oo.features.id_n:
                        return enum_moreInfo_featuresIds_s

                    case this.outerTabs_oo.emails.id_n:
                        return enum_emailsIds_uid


                }
            },
            co_getSelectedData_o(){

                if(this.innerTab_selectTabId_s == null){
                    return null
                }

                switch(this.outerTab_selectedTabId_n){

                    // blog
                    case this.outerTabs_oo.blog.id_n:
                        return this.server_articlesData_byArticleId_c[this.innerTab_selectTabId_s]
                    // questMolds
                    case this.outerTabs_oo.questMolds.id_n:
                        return this.server_questMolds_byQuestId_c[this.innerTab_selectTabId_s]
                    // adminEmails
                    case this.outerTabs_oo.emails.id_n:
                        if(this.server_adminEmails_byId_uid[this.innerTab_selectTabId_s] === undefined) {
                            this.showLoader_b = true

                            this.$set(this.server_adminEmails_byId_uid, this.innerTab_selectTabId_s, null)

                            serverBig_adminEmail_getOnce_f({
                                emailId_s: this.innerTab_selectTabId_s,
                                cb_f : (adminEmail_c) => {


                                    if(adminEmail_c == null){
                                        adminEmail_c= new FB_AdminEmail({
                                            ae_id_uid       : this.innerTab_selectTabId_s,
                                            ae_title_blc_s  : {},
                                            ae_body_blc_html : {},
                                        })
                                    }

                                    this.showLoader_b = false
                                    this.server_adminEmails_byId_uid[this.innerTab_selectTabId_s] = adminEmail_c

                                },
                                cb_error_f : () => {

                                    this.showLoader_b = false

                                    this.server_adminEmails_byId_uid[this.innerTab_selectTabId_s] = new FB_AdminEmail({
                                        ae_id_uid       : this.innerTab_selectTabId_s,
                                        ae_title_blc_s  : {},
                                        ae_body_blc_html : {},
                                    })
                                }
                            })


                        }
                        return this.server_adminEmails_byId_uid[this.innerTab_selectTabId_s]

                    // features
                    case this.outerTabs_oo.features.id_n:
                    // versions
                    case this.outerTabs_oo.versions.id_n:
                    // helpers
                    case this.outerTabs_oo.helpers.id_n:

                        if(this.server_moreInfo_byId_c[this.innerTab_selectTabId_s] === undefined){
                            this.$set(this.server_moreInfo_byId_c, this.innerTab_selectTabId_s, null)
                            this.showLoader_b = true

                            serverPre_moreInfo_get_one_f({
                                mi_id_uid: this.innerTab_selectTabId_s,
                                cb_f : (moreInfo_c) => {

                                    if(moreInfo_c == null){
                                        moreInfo_c =  new FB_MoreInfo({
                                            mi_id_uid       : this.innerTab_selectTabId_s,
                                            mi_lastEdit_t   : date_nowTime_t(),
                                        })
                                    }
                                    this.server_moreInfo_byId_c[this.innerTab_selectTabId_s] = moreInfo_c
                                    this.showLoader_b = false

                                }
                            })
                        }
                        return this.server_moreInfo_byId_c[this.innerTab_selectTabId_s]
                }
            },

            // testEmail
            co_previewEmail_title_fs(){
                let ans = this.server_adminEmails_byId_uid[this.innerTab_selectTabId_s].ae_title_blc_s[this.innerTab_selectedLangCode_e]

                let data_var_o = {
                    creatorName_s : "Dan Gadasi",
                    month_s : "October 2021",
                }

                // v-for
                return email_swapVars_f( {text_s:ans, data_if_o: null, data_for_oao: null, data_var_o: data_var_o});

            },
            co_previewEmail_body_fs(){
                let ans = this.server_adminEmails_byId_uid[this.innerTab_selectTabId_s].ae_body_blc_html[this.innerTab_selectedLangCode_e]

                let data_if_o = {
                    showBankInfo_b: false,
                    showBankInfoError: true,
                    showSoldTickets_b: false,
                    showCreatedTickets_b: true,

                }

                let data_for_oao = {
                    tableData_ao1 : [
                        {ticketsId_uid: "1", saleDate_s : "test1", price_s: "test1", eventName_s: "test1", eventDate_s : "test1", agent_s: "test1", status_s: "test1", backgroundColor_s:"red"},
                        {ticketsId_uid: "2", saleDate_s : "test1", price_s: "test1", eventName_s: "test1", eventDate_s : "test1", agent_s: "test1", status_s: "test1", backgroundColor_s:"green"},
                        {ticketsId_uid: "3", saleDate_s : "test1", price_s: "test1", eventName_s: "test1", eventDate_s : "test1", agent_s: "test1", status_s: "test1", backgroundColor_s:"green"},
                        {ticketsId_uid: "4", saleDate_s : "test1", price_s: "test1", eventName_s: "test1", eventDate_s : "test1", agent_s: "test1", status_s: "test1"},
                    ],
                    tableData_ao2 : [
                        {ticketsId_uid: "1", saleDate_s : "test2", price_s: "test2", eventName_s: "test2", eventDate_s : "test2", spots_s: "1/3", more_s: "test2"},
                        {ticketsId_uid: "2", saleDate_s : "test1", price_s: "test1", eventName_s: "test1", eventDate_s : "test1", spots_s: "3/3", more_s: "test1"},
                        {ticketsId_uid: "3", saleDate_s : "test1", price_s: "test1", eventName_s: "test1", eventDate_s : "test1", spots_s: "5/10", more_s: "test1"},
                        {ticketsId_uid: "4", saleDate_s : "test1", price_s: "test1", eventName_s: "test1", eventDate_s : "test1", spots_s: "11/20", more_s: "test1"},
                    ],
                }

                let data_var_o = {
                    // creatorName_s : "Dan Gadasi",
                    totalIncome_s : "20$, 20₪",
                    bank_s : "Leumi (10)",
                    branch_s : "941",
                    accountNumber_s : "1233221123",

                    totalPayment_s : "20$",
                    totalTickets_s : "70",

                    month_s : "October 2021",


                    // newReview
                    // questName_s : "Quest Name",
                    // playerName_s : "Dan Gadasi",
                    playerEmail_s : "dan@travelAndQuest.com",
                    overallRating_n : "4",
                    difficultyLevel_n : "3",
                    publicReview_s : "This is great",
                    privateReview_s : "you should do something else better",

                    // finishQuest
                    // playerName_s : "Dan Gadasi",
                    questName_s : "Quest Name",
                    // creatorMsg_s : "hello hello this is really great and stuff",
                    // creatorName_s : "Dan Gadasi",
                    // creatorEmail_s : "dan@travelAndQuest.com",


                    // ticket
                    eventName_s: "Quest Name",
                    playerName_s : "Dan Gadasi",
                    ticketLink_s : "google.com",
                    shortCode_s : "abcdef",

                    creatorMsg_s : "hello hello this is really great and stuff",

                    creatorName_s : "Dan Gadasi",
                    creatorPhone_s : "050-1234567",
                    creatorEmail_s : "dan@travelAndQuest.com",

                    ticketId_uid : "123123123123",
                    ticketDate_s : "22/1/05",
                    spots_s : "20",
                    price_s : "10$",


                }

                // v-for
                return email_bodyWrapper_fs(email_swapVars_f( {text_s:ans, data_if_o: data_if_o, data_for_oao: data_for_oao, data_var_o: data_var_o}), this.innerTab_selectedLangCode_e)

            },

        },
        methods:{

            // all
            m_outerTab_clickTab_f(newTab_n){
                this.innerTab_selectTabId_s = null
                this.outerTab_selectedTabId_n = newTab_n;
            },
            m_innerTab_addNew_f(){
                switch(this.outerTab_selectedTabId_n){

                    case this.outerTabs_oo.blog.id_n:
                        server_blogArticle_getNewTicket_f((newBlogArticle_c) => {
                            this.$set(this.server_articlesData_byArticleId_c, newBlogArticle_c.ba_articleId_uid , newBlogArticle_c)
                        })
                        break;

                    case this.outerTabs_oo.questMolds.id_n:
                        this.$set(this.server_questMolds_byQuestId_c, 'New Mold' , new FB_QuestMold({
                            qm_questId_uid : 'New Mold',
                            qm_minPlayerPoints_n: 0
                        }))

                        break;


                    case this.outerTabs_oo.versions.id_n:
                    case this.outerTabs_oo.helpers.id_n:
                    case this.outerTabs_oo.features.id_n:
                    case this.outerTabs_oo.emails.id_n:
                        break;
                }
            },
            m_update_f(){
                this.showLoader_b = true

                switch(this.outerTab_selectedTabId_n) {

                    case this.outerTabs_oo.blog.id_n:
                        server_forumData_set_f(this.co_getSelectedData_o, () => {
                            notification_notify(ass_strings.oneWord_updated)
                            this.showLoader_b = false
                        })

                        break;

                    case this.outerTabs_oo.questMolds.id_n:

                        serverBig_questExplore_once_f(this.co_getSelectedData_o.qm_questId_uid, false, false, (questExplore_c) => {
                            serverBig_questBody_once_fp(questExplore_c.qex_questType_e, questExplore_c.qex_questId_uid, false,(questBody_c) => {

                                server_questMold_update_f(this.co_getSelectedData_o, () => {
                                    notification_notify(ass_strings.oneWord_updated)
                                    this.showLoader_b = false
                                })
                            })
                        })


                        break;
                    case this.outerTabs_oo.emails.id_n:
                        serverBig_adminEmail_update_f(this.co_getSelectedData_o, () => {
                            notification_notify(ass_strings.oneWord_updated)
                            this.showLoader_b = false
                        })
                        break;

                    case this.outerTabs_oo.versions.id_n:
                    case this.outerTabs_oo.helpers.id_n:
                    case this.outerTabs_oo.features.id_n:

                        serverPre_moreInfo_update_f({
                            moreInfo_c : this.co_getSelectedData_o,
                            cb_f : () => {
                                notification_notify(ass_strings.oneWord_updated)
                                this.showLoader_b = false
                            }})
                        break;



                }

            },
            m_chooseFile_f(cb_f){
                this.popup_chooseFile_cb_f = (file_c) => {
                    this.popup_chooseFile_show_vb.val = false
                    cb_f(file_c)
                }

                this.popup_chooseFile_show_vb.val = true
            },
            m_pushSlide_f(){

                if(this.co_getSelectedData_o.so_slides_blc_ac[this.innerTab_selectedLangCode_e] == null){
                    this.$set(this.co_getSelectedData_o.so_slides_blc_ac, this.innerTab_selectedLangCode_e, [])
                }
                this.co_getSelectedData_o.so_slides_blc_ac[this.innerTab_selectedLangCode_e].push(new FB_SlideData({}))
            },

            // testEmail
            m_test_formatForLoops_f(text_s, data_if_o, data_for_oao, data_var_o){

                // 1) v-if
                if(data_if_o){
                    for(let key in data_if_o){
                        text_s = text_s.replace(re_startAndEndWith_s(`<ifdiv v-if=\"${key}\"`, "</ifdiv>"),  (div_s) => {

                            let ifName_s = ""
                            div_s = div_s.replace(re_startAndEndWith_s("v-if=\"", "\""), (vIf_s) => {
                                ifName_s = vIf_s.substring(6, vIf_s.length -1)
                                return ''
                            })

                            if(!data_if_o[ifName_s]) {
                                return '<div> </div>'
                            }

                            return div_s.replace('ifdiv', 'div')
                        })
                    }
                }

                // 2) vFor for tr
                if(data_for_oao){
                    text_s = text_s.replace(re_startAndEndWith_s("<tr v-for=", "</tr>"),  (row_s) => {
                        let forLoopVarName_s = ""

                        // get v-for
                        row_s.replace(re_startAndEndWith_s("v-for=\"", "\""), (vFor_s) => {
                            forLoopVarName_s = vFor_s.substring(7, vFor_s.length -1)
                            return vFor_s
                        })

                        // replace all
                        let ans_s = ''
                        for(let index_n in data_for_oao[forLoopVarName_s]){
                            let td_o = data_for_oao[forLoopVarName_s][index_n]
                            let newRow_s = row_s
                            for(let key_s in td_o){
                                newRow_s = newRow_s.replace(`{{${key_s}}}`, td_o[key_s])
                            }
                            ans_s += newRow_s
                        }

                        return ans_s;
                    });
                }

                // 3) other variables
                if(data_var_o){
                    for(let key_s in data_var_o){
                        text_s = text_s.replaceAll(`{{${key_s}}}`, data_var_o[key_s])
                    }
                }

                // 4) return ans
                return text_s
            },
            m_test_functions_f(){

                let adminEmail_c = new FB_AdminEmail({"ae_id_uid":"3jYHe0ysEhZ9JOq2AdFT","ae_label_s":"monthlySum_uid","ae_title_blc_s":{"en":"Monthly Summary - {{month_s}} - {{creatorName_s}} ","iw":"","fr":"","es":"","ar":"","nl":""},"ae_body_blc_html":{"en":"<div>\n    </div><div style=\"background:#885ead;padding: 8px;\">\n        <div style=\"max-width:800px;margin: auto;text-align:center;background: white;padding: 16px;/* margin: 8px; */border-radius: 5px;\">\n    \n    \n    \n    <div><div style=\"text-align: justify; border-radius: 5px;\"><span style=\"color: rgb(34, 34, 34); font-size: 28px; text-align: start;\"><div style=\"\"><img src=\"https://firebasestorage.googleapis.com/v0/b/travelquestdev.appspot.com/o/USERS_DRIVE%2FoCsxl7xJMbdRm6oDSRmuhVlYnSA3%2F1636364328189.jpg?alt=media&amp;token=82f48008-2e4b-4507-a75e-e73312f9f86c\" style=\"cursor: pointer;border-radius: 5px;width: 100%;\"></div></span></div><div style=\"border-radius: 5px; text-align: center;\"><span style=\"font-weight: bold;\"><span style=\"color: rgb(34, 34, 34); font-size: 28px; text-align: start;\">Monthly Summary -&nbsp;</span><span style=\"color: rgb(34, 34, 34); font-size: 28px; text-align: start;\">{{month_s}}&nbsp;</span></span></div><div style=\"border-radius: 5px; text-align: center;\"><span style=\"color: rgb(34, 34, 34); font-size: 28px; text-align: start; font-weight: bold;\">{{creatorName_s}}&nbsp;</span></div></div><div style=\"text-align: justify; border-radius: 5px;\"><br></div><div style=\"text-align: justify; border-radius: 5px;\"><hr></div><div style=\"text-align: justify;\"><ifdiv v-if=\"showSoldTickets_b\" style=\"color: rgb(34, 34, 34); text-align: start; margin: 12px 0px;\"><div style=\"font-size: 24px; margin: 8px 0px; background: rgb(46, 41, 78); color: white; padding: 8px 0px;\">&nbsp; Sold Tickets</div><div style=\"font-size: small; overflow-x: auto;\"><table style=\"border: 1px solid black;border-collapse: collapse;width: 100%;text-align: center;\"><tbody><tr style=\"background: rgb(187, 163, 208); font-weight: bold; font-size: 20px;\"><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Ticket Id</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Purchest Date</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Price<br></td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Event Name</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Event Date</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Agent</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Status<br></td></tr><tr v-for=\"tableData_ao1\"><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{ticketsId_uid}}<br></td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">*{{saleDate_s}}<br></td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{price_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{eventName_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{eventDate_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{agent_s}}<br></td><td style=\"margin: 0px; border: 1px solid black; padding: 8px; background:{{backgroundColor_s}}\">{{status_s}}</td></tr></tbody></table></div><div style=\"font-size: 20px; margin: 8px 0px;\"><b style=\"font-size: small;\"></b><div style=\"font-size: small;\"><b><div><b>*Timezone :&nbsp;</b>GMT+0200</div><div><br></div></b></div></div><div style=\"font-size: 20px; margin: 8px 0px;\">Total Income:<b> {{totalIncome_s}}</b><span style=\"font-weight: 700;\">&nbsp;</span><br></div><div style=\"/* margin: 8px 0px; */\"><span style=\"font-size: large;\">The payment will be transfer at the 10th of the month to the next bank account:&nbsp;</span></div><ifdiv v-if=\"showBankInfo_b\" style=\"/* margin: 8px 0px; */\"><span style=\"font-size: large;\">Bank: <b style=\"\">{{bank_s}}</b>, Branch:<b style=\"\"> {{branch_s}}</b>, Account Number: <b style=\"\">{{accountNumber_s}}.</b></span></ifdiv><ifdiv v-if=\"showBankInfoError\" style=\"margin: 8px 0px;\"><div style=\"font-family: Arial, Helvetica, sans-serif; font-size: small;\"><div style=\"font-size: 20px; margin: 8px 0px;\"><div style=\"color: red;\"><span style=\"font-weight: bold;\">Please fill your bank account info!</span></div><div style=\"color: red;\"><span style=\"font-weight: bold;\"><br></span></div></div></div></ifdiv><div style=\"font-size: 20px; margin: 8px 0px;\"><hr></div></ifdiv> <ifdiv v-if=\"showCreatedTickets_b\" style=\"text-align: start; margin: 12px 0px;\"><div style=\"color: white; font-size: 24px; margin: 8px 0px; background: rgb(46, 41, 78); padding: 8px 0px;\">&nbsp; Created Tickets</div><div style=\"color: rgb(34, 34, 34); font-size: small; overflow-x: auto;\"><table style=\"border: 1px solid black;border-collapse: collapse;width: 100%;text-align: center;\"><tbody><tr style=\"background: rgb(187, 163, 208); font-weight: bold; font-size: 20px;\"><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Ticket Id</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Sale Date</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Price</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Event Name</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Event Date</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">Spots</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">More Info</td></tr><tr v-for=\"tableData_ao2\"><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{ticketsId_uid}}<br></td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">*{{saleDate_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{price_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{eventName_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{eventDate_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{spots_s}}</td><td style=\"margin: 0px; border: 1px solid black; padding: 8px;\">{{more_s}}</td></tr></tbody></table></div><div style=\"color: rgb(34, 34, 34); font-size: 20px; margin: 8px 0px;\"><b style=\"font-size: small;\"></b><div style=\"font-size: small;\"><b><div><b>*Timezone :&nbsp;</b>GMT+0200</div><div><br></div></b></div></div><div style=\"margin: 8px 0px;\"><span style=\"color: rgb(34, 34, 34); font-size: 20px;\">You have Created&nbsp;</span><span style=\"color: rgb(34, 34, 34); font-size: 20px; font-weight: bold;\">{{totalTickets_s}}&nbsp;</span><span style=\"color: rgb(34, 34, 34); font-size: 20px; font-weight: bold;\">Tickets,&nbsp;</span><span style=\"color: rgb(34, 34, 34); font-size: 20px;\">Cost:&nbsp;</span><b style=\"color: rgb(34, 34, 34); font-size: 20px;\">{{totalPayment_s}}.</b></div><div style=\"margin: 8px 0px;\"><span style=\"color: rgb(34, 34, 34); font-size: large;\">Your credit card will be charge at the 10th of the month.</span><span style=\"color: rgb(34, 34, 34); font-size: large;\">&nbsp;</span></div><div style=\"margin: 8px 0px;\"><span style=\"color: rgb(34, 34, 34); font-size: large;\"><br></span></div></ifdiv></div><div style=\"border-top: 1px solid black; text-align: initial;\"><div style=\"background-image: initial;background-position: initial;background-size: initial;background-repeat: initial;background-attachment: initial;background-origin: initial;background-clip: initial;/* margin-bottom: 8px; */padding-top: 8px;direction: ltr;\"><table style=\"text-align: justify;width: 100%;\"><tbody><tr><td><div>Dan@TravelAndQuest.com</div><div>Sderot Tsahal 4, Lod, Israel</div><div>303035596</div><a href=\"http://travelandquest.com/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=http://TravelAndQuest.com&amp;source=gmail&amp;ust=1636312136382000&amp;usg=AFQjCNE5CE4_2hTJaRd0rMykG_XmIK1p7A\">TravelAndQuest.com</a></td><td style=\"text-align: right;\"><img src=\"https://ci3.googleusercontent.com/proxy/YXQA0jGg3d2NXnm9fYG6STgR6ohNcVXe_7esZkvuZUPzzEXIDdKg0k9H9oY1ybjnPl4i9wjtC76-XX29WnbkFYZIqS5_BwzV38WdT20D44PWhDWPPm6qSd_-9hmuXoONaj9pTkVYsOlKWowMDbPRCVl-PErSxcM7hMgcXdr0xFgeixGFdFgrlN0uSbiOw3497fbtfQdDOttdNjD6cbOtI2wwtAvozB8u0ZwajM2U1lbhlivs76g=s0-d-e1-ft#https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Fapple-touch-icon-120x120.png?alt=media&amp;token=ded9d127-7038-4b0d-8e4c-de571e6eabba\" class=\"CToWUd\" style=\"width: 90px; border-radius: 16px;\"></td></tr></tbody></table></div></div>\n        </div>\n        </div>\n        ","iw":"<div><div style=\"text-align: justify; border-radius: 5px;\"><br><br></div></div>","fr":"","es":"","ar":"","nl":""}})

                let tickets_byId_o = {"-MnQw2FW6-0OE9-9F1UP":{"qt_ticketId_uid":"-MnQw2FW6-0OE9-9F1UP","qt_shortKeyId_s":"00kme1","qt_questType_e":"MISSIONS","qt_questId_uid":"hWUIrr1vPcjoc53easS0","qt_eventId_uid":"-MnQw-YKuR5qyGCW4JtU","qt_playerId_uid":"oCsxl7xJMbdRm6oDSRmuhVlYnSA3","qt_creatorId_uid":"oCsxl7xJMbdRm6oDSRmuhVlYnSA3","qt_eventStartingDate_t":1635717660000,"qt_playersJoinDate_byUserId_t":{"oCsxl7xJMbdRm6oDSRmuhVlYnSA3":3213213},"qt_saleDate_t":1635777480000,"qt_purchasedBy_e":5,"qt_status_e":"approved","qt_history_ac":[{"qth_timestamp_t":1635777480000,"qth_actions_e":"approve","qth_refund_c":null}],"qt_spots_n":5,"qt_cost_c":{"c_currency_e":1,"c_value_n":0},"qt_discountPercentage_n":0,"qt_creatorText_s":""},"-Mo-87-XD5aoWXyS9BJv":{"qt_ticketId_uid":"-Mo-87-XD5aoWXyS9BJv","qt_shortKeyId_s":"00i1rj","qt_questType_e":"MISSIONS","qt_questId_uid":"hWUIrr1vPcjoc53easS0","qt_eventId_uid":"-Mo-82puR0yfr8U2ZhRr","qt_playerId_uid":"oCsxl7xJMbdRm6oDSRmuhVlYnSA3","qt_creatorId_uid":"oCsxl7xJMbdRm6oDSRmuhVlYnSA3","qt_eventStartingDate_t":1635753600000,"qt_playersJoinDate_byUserId_t":{},"qt_saleDate_t":1636384920000,"qt_purchasedBy_e":5,"qt_status_e":"approved","qt_history_ac":[{"qth_timestamp_t":1636384920000,"qth_actions_e":"approve","qth_refund_c":null}],"qt_spots_n":1,"qt_cost_c":{"c_currency_e":1,"c_value_n":0},"qt_discountPercentage_n":0,"qt_creatorText_s":""}}
                let tickets_byId_c = obj_map_fo(tickets_byId_o, (item) => new FB_QuestTicket(item))

                let questEvents_byEventKey_o = {"MISSIONS_hWUIrr1vPcjoc53easS0_-MnQw-YKuR5qyGCW4JtU":{"qev_supportedLangCodes_ae":["iw","en"],"qev_defaultLang_e":"iw","qev_name_byLangCode_s":{"en":"levels(copy)","iw":"שלבים(copy)"},"qev_startingDate_t":1635717660000,"qev_emailFinishQuest_blc_s":{"en":"Thank you for playing our quest, We'll be happy if you leave a review on the website.","iw":"תודה ששחקתם את הקווסט שלנו, נשמח אם תשארו ביקורת באתר."},"qev_emailBoughtTicket_blc_s":{"en":"Thank you for purchasing this quest entry ticket, please for any question feel free to contact me.","iw":"תודה שרכשתם כרטיס כניסה, אם יש שאלות אני אשמח לשמוע."},"qev_durationInMinutes_n":180,"qev_ticketsStatus_byTicketId_b":{"-MnQw2FW6-0OE9-9F1UP":true},"qev_questType_e":"MISSIONS","qev_questId_uid":"hWUIrr1vPcjoc53easS0","qev_eventId_uid":"-MnQw-YKuR5qyGCW4JtU","qev_creatorId_uid":"oCsxl7xJMbdRm6oDSRmuhVlYnSA3","qev_utcOffSetHours_n":2,"qev_imgFile_blc_c":{"en":{"fi_type_e":"image/jpeg","fi_fileName_s":"rWp75WIo4ypps2w3EsRH","fi_url_s":"https://firebasestorage.googleapis.com/v0/b/travelquestdev.appspot.com/o/QUESTS_EXPLORE%2FMISSIONS%2FrWp75WIo4ypps2w3EsRH%2FrWp75WIo4ypps2w3EsRH_undefined.jpg?alt=media&token=4f49cac9-b230-43ab-be0f-d4f841e7b121","fi_uploadDate_t":1600633045243,"fi_uploadStatus_n":1,"fi_sizeBytes_n":94500,"fi_folderFiles_byUploadDate_c":{},"fi_index_n":0},"iw":{"fi_type_e":"image/jpeg","fi_fileName_s":"rWp75WIo4ypps2w3EsRH","fi_url_s":"https://firebasestorage.googleapis.com/v0/b/travelquestdev.appspot.com/o/QUESTS_EXPLORE%2FMISSIONS%2FrWp75WIo4ypps2w3EsRH%2FrWp75WIo4ypps2w3EsRH_undefined.jpg?alt=media&token=4f49cac9-b230-43ab-be0f-d4f841e7b121","fi_uploadDate_t":1600633045243,"fi_uploadStatus_n":1,"fi_sizeBytes_n":94500,"fi_folderFiles_byUploadDate_c":{},"fi_index_n":0}},"qev_playersNum_n":5,"qev_startClockType_e":"playerStartClock"},"MISSIONS_hWUIrr1vPcjoc53easS0_-Mo-82puR0yfr8U2ZhRr":{"qev_supportedLangCodes_ae":["iw","en"],"qev_defaultLang_e":"iw","qev_name_byLangCode_s":{"en":"levels(copy)","iw":"שלבים(copy)"},"qev_startingDate_t":1635753600000,"qev_emailFinishQuest_blc_s":{"en":"Thank you for playing our quest, We'll be happy if you leave a review on the website.","iw":"תודה ששחקתם את הקווסט שלנו, נשמח אם תשארו ביקורת באתר."},"qev_emailBoughtTicket_blc_s":{"en":"Thank you for purchasing this quest entry ticket, please for any question feel free to contact me.","iw":"תודה שרכשתם כרטיס כניסה, אם יש שאלות אני אשמח לשמוע."},"qev_durationInMinutes_n":180,"qev_ticketsStatus_byTicketId_b":{"-Mo-87-XD5aoWXyS9BJv":true},"qev_questType_e":"MISSIONS","qev_questId_uid":"hWUIrr1vPcjoc53easS0","qev_eventId_uid":"-Mo-82puR0yfr8U2ZhRr","qev_creatorId_uid":"oCsxl7xJMbdRm6oDSRmuhVlYnSA3","qev_utcOffSetHours_n":2,"qev_imgFile_blc_c":{"en":{"fi_type_e":"image/jpeg","fi_fileName_s":"rWp75WIo4ypps2w3EsRH","fi_url_s":"https://firebasestorage.googleapis.com/v0/b/travelquestdev.appspot.com/o/QUESTS_EXPLORE%2FMISSIONS%2FrWp75WIo4ypps2w3EsRH%2FrWp75WIo4ypps2w3EsRH_undefined.jpg?alt=media&token=4f49cac9-b230-43ab-be0f-d4f841e7b121","fi_uploadDate_t":1600633045243,"fi_uploadStatus_n":1,"fi_sizeBytes_n":94500,"fi_folderFiles_byUploadDate_c":{},"fi_index_n":0},"iw":{"fi_type_e":"image/jpeg","fi_fileName_s":"rWp75WIo4ypps2w3EsRH","fi_url_s":"https://firebasestorage.googleapis.com/v0/b/travelquestdev.appspot.com/o/QUESTS_EXPLORE%2FMISSIONS%2FrWp75WIo4ypps2w3EsRH%2FrWp75WIo4ypps2w3EsRH_undefined.jpg?alt=media&token=4f49cac9-b230-43ab-be0f-d4f841e7b121","fi_uploadDate_t":1600633045243,"fi_uploadStatus_n":1,"fi_sizeBytes_n":94500,"fi_folderFiles_byUploadDate_c":{},"fi_index_n":0}},"qev_playersNum_n":1,"qev_startClockType_e":"eventStartClock"}}
                let questEvents_byEventKey_c = obj_map_fo(questEvents_byEventKey_o, (item) => new FB_QuestEvent(item))
                let creatorData_byUserId_o = {"oCsxl7xJMbdRm6oDSRmuhVlYnSA3":{"ud_userId_uid":"oCsxl7xJMbdRm6oDSRmuhVlYnSA3","ud_avatar_c":{"cuda_avatarImage_b":false,"cuda_imgFile_c":{"fi_fileName_s":"","fi_uploadDate_t":1633591176701,"fi_uploadStatus_n":0,"fi_sizeBytes_n":0,"fi_folderFiles_byUploadDate_c":{},"fi_index_n":0},"cuda_top_e":"ShortRound","cuda_hairColor_s":"#008000","cuda_clothing_e":"ShirtScoopNeck","cuda_eyes_e":"Default","cuda_mouth_e":"Smile","cuda_eyebrow_e":"Default","cuda_facialHair_e":"blank","cuda_accessories_e":"blank","cuda_clothingColor_s":"#FFD700"},"ud_name_s":"Dan Gadasi","ud_email_s":"dan@travelandquest.com","ud_accessLevel_n":10,"ud_langCode_e":"en","ud_utcOffSetHours_n":2,"ud_tqProfitPercentage_n":20,"ud_paymentPlan_e":{"2021-10":"freePlan"},"ud_loginMethods_ae":[]}}
                let creatorData_byUserId_c = obj_map_fo(creatorData_byUserId_o, (item) => new FB_UserData(item))

                let uds_paymentInfo_byUserId_o = {"oCsxl7xJMbdRm6oDSRmuhVlYnSA3":null}
                let uds_paymentInfo_byUserId_c = obj_map_fo(uds_paymentInfo_byUserId_o, (item) => new FB_UserDataSub_CreatorPaymentInfo(item))

                // sf_monthSummary_generateSummaries_f({
                //     adminEmail_c                : adminEmail_c,
                //     tickets_byTicketId_c        : tickets_byId_c,
                //     questEvents_byEventKey_c    : questEvents_byEventKey_c,
                //     creatorData_byUserId_c      : creatorData_byUserId_c,
                //     uds_paymentInfo_byUserId_c  : uds_paymentInfo_byUserId_c,
                //     summaryCb_f: (adminCreatorPaymentStatus_c) => {
                //         console.log(adminCreatorPaymentStatus_c)
                //     }
                // })
            },




        },
    }
</script>

<style scoped lang="scss">

table, tr, td{
    border: 1px solid black
}


</style>